/**
 * LangIcon
 * Simplified Lang logo mark as inline SVG.
 */
const LangIcon = ({ size = 18 }) => (
    <svg width={size} height={size}
        viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.86 4.88H8.3L7.5 7.32H7.28C6.49 7.29 5.73 7.1 5.01 6.76L4.64 6.58L4.92 6.28C5.82 5.34 6.41 4.17 6.63 2.9L6.67 2.65H7.54V1.63H4.29V0H3.26V1.62H0.02V2.64H5.65L5.56 3.01C5.31 4.05 4.77 5 3.99 5.75L3.78 5.95L3.57 5.75C3.3 5.49 3.04 5.19 2.82 4.87H1.62C1.9 5.38 2.24 5.85 2.64 6.27L2.92 6.57L2.55 6.75C1.79 7.12 0.97 7.31 0.11 7.31H0V8.33H0.11C1.35 8.33 2.56 7.98 3.61 7.33L3.77 7.23L3.93 7.33C4.79 7.87 5.78 8.2 6.78 8.3L7.15 8.34L5.83 12.4H6.91L7.44 10.78H10.68L11.21 12.4H12.29L9.84 4.88H9.86ZM7.79 9.75L9.08 5.8L10.37 9.75H7.8H7.79Z" fill="#07080B" />
    </svg>
);

export default LangIcon;
